export const WORKSPACE_LOCAL_MAX = 20

export class WorkspaceValidationError extends Error {
  /** @param {'duplicate_name' | 'cap_reached'} code */
  constructor(code, message) {
    super(message)
    this.name = 'WorkspaceValidationError'
    this.code = code
  }
}

export function assertWorkspaceNameAvailable(workspaces, name) {
  const trimmed = String(name || '').trim()
  if (
    workspaces.some((row) => String(row.name || '').trim().toLowerCase() === trimmed.toLowerCase())
  ) {
    throw new WorkspaceValidationError('duplicate_name', 'A workspace with this name already exists.')
  }
}

export function assertWorkspaceCap(workspaces) {
  if (workspaces.length >= WORKSPACE_LOCAL_MAX) {
    throw new WorkspaceValidationError(
      'cap_reached',
      `You can create up to ${WORKSPACE_LOCAL_MAX} workspaces.`,
    )
  }
}
